module.exports = __webpack_public_path__ + "img/color_block_11.8722e3d2.svg";